import type { AgentSopSummary } from '@erp/rpc';
import { Badge } from 'src/components/ui/badge';
import { SOP_STATUS_VARIANT, sopLabel } from './procedureDisplay';

/**
 * The Name column body shared by the main Procedures list and the agent's Procedures tab — label
 * over kebab name, with a status chip only when the status is worth flagging.
 */
export function ProcedureNameCell({ sop }: { sop: AgentSopSummary }) {
  return (
    <div>
      <div className="flex items-center gap-2">
        <span className="font-medium">{sopLabel(sop)}</span>
        {/* Only surface a status chip when it's NOT the common "active" — an all-active column is
            noise, but a draft/archived row is worth flagging. */}
        {sop.status !== 'active' && (
          <Badge variant={SOP_STATUS_VARIANT[sop.status] ?? 'outline'}>
            {sop.status}
          </Badge>
        )}
      </div>
      <p className="mt-0.5 font-mono text-xs text-muted-foreground">
        {sop.name}
      </p>
    </div>
  );
}
